import * as React from "react";
import PieChart from "@cloudscape-design/components/pie-chart";
import Box from "@cloudscape-design/components/box";
import Button from "@cloudscape-design/components/button";
import { VehicleMasterTable } from "./data list vehicle/data";
import { Spinner } from "@cloudscape-design/components";


interface DataItem {
  title: string;
  percentage: number;
  value: number;
}

interface StatusVehicleProps {
  vehicles: VehicleMasterTable[];
}

const StatusVehicle: React.FC<StatusVehicleProps> = ({ vehicles }) => {
  const data: DataItem[] = React.useMemo(() => {
    const locationCount: { [key: string]: number } = {};

    vehicles.forEach(vehicle => {
      if (vehicle.Location) {
        locationCount[vehicle.Location] = (locationCount[vehicle.Location] || 0) + 1;
      }
    });

    const dataArray: DataItem[] = Object.keys(locationCount).map(title => ({
      title,
      value: locationCount[title],
      percentage: 0
    }));

    const total = dataArray.reduce((acc, item) => acc + item.value, 0);

    dataArray.forEach(item => {
      item.percentage = Math.round((item.value / total) * 100);
    });

    return dataArray;
  }, [vehicles]);

  const total = data.reduce((acc, item) => acc + item.value, 0);
 
  

  return (
    <div style={{ textAlign: "center" }}>
      <h3 style={{ marginTop: "0px" }}>Vehicle Locations</h3>
      <PieChart
        data={data}
        visibleSegments={data}
        ariaDescription="Donut chart showing vehicle Location."
        ariaLabel="Donut chart"
        hideFilter
        hideTitles
        hideLegend
        innerMetricDescription="total units"
        innerMetricValue={total.toString()}
        size="small"
        variant="donut"
        empty={
          <Box textAlign="center" color="inherit">
            <b>No data available</b>
            <Box variant="p" color="inherit">
              There is no data available
            </Box>
          </Box>
        }
        noMatch={
          <Box textAlign="center" color="inherit">
            <b>No matching data</b>
            <Box variant="p" color="inherit">
              There is no matching data to display
            </Box>
            <Button>Clear filter</Button>
          </Box>
        }
      />
    </div>
  );
};

export default StatusVehicle;
